import {FunctionComponent, PropsWithChildren} from 'react';
import {Title} from 'react-head';

type PageProps = {
  title: string;
};
export const Page: FunctionComponent<PropsWithChildren<PageProps>> = ({title, children}) => {
  return (
    <>
      <Title>{title}</Title>
      {children}
    </>
  );
};
